// removed by extract-text-webpack-plugin
module.exports = {"center":"Loading__center","loader":"Loading__loader","loading":"Loading__loading","cls":"Loading__cls"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Loading/Loading.css
// module id = 1193
// module chunks = 8